import SwiperCore, { Autoplay, EffectFade, Pagination } from 'swiper';
import Swiper from 'swiper';

export function homeSlider() {
  const $slider = $('.home-slider');
  if (!$slider || !$slider.length) return;

  SwiperCore.use([Pagination, Autoplay, EffectFade]);

  const swiper = new Swiper('.home-slider', {
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    } /*
    autoplay: {
      delay: 5000,
    },*/,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
  });
}
